import { api } from "./api";


// Auth
export const register = (data) => {
    return api.post("/user/register", data);
};

export const verify = (id, data) => {
    return api.post(`/user/verify/${id}`, data);
};

export const login = (data) => {
    return api.post("/user/login", data);
};

export const forgot = (data) => {
    return api.post("/user/forgetpassword", data);
};

export const reset = (data) => {
    return api.put("/user/resetpassword", data);
};

export const logout = () => {
    return api.get("/user/logout");
};

export const getCurrentUser = () => {
    return api.get("/user/getMyProfile");
};

export const updateProfile = (data) => {
    return api.put("/user/updateProfile", data);
};


export const createPaymentIntent = (data) => {
    return api.post("/payment/createPaymentIntent", data);
};



export const postCreateOrder = (data) => {
    return api.post("/payment/create-order", data);
};

export const postVerifyPayment = (data) => {
    return api.post("/payment/verify-payment", data);
};

export const sendInvoice = (data) => {
    return api.post("/payment/sendInvoice", data);
};
//blog
export const postBlog = (formData) => {
    return api.post("/blog/create", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getAllBlogs = () => {
    return api.get("/blog/getall");
};

export const getCountryBasedBlogs = () => {
    return api.get("/blog/getCountryBasedBlogs");
};



export const getBlogById = (id) => {
    return api.get(`/blog/getBlogById/${id}`);
};
export const getBlogByCountry = (country) => {
    return api.get(`/blog/getBlogByCountry?country=${country}`);
};

export const deleteBlog = (id) => {
    return api.delete(`/blog/delete/${id}`);
};

export const updateBlog = (id, formData) => {
    return api.put(`/blog/update/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};


//event


export const postEvent = (data) => {
    return api.post("/event/create", data);
};

export const getAllEvents = () => {
    return api.get("/event/getall");
};

export const getCountryBasedEvents = () => {
    return api.get("/event/getCountryBasedEvents");
};




export const getEventById = (id) => {
    return api.get(`/event/getEventById/${id}`);
};
export const deleteEvent = (id) => {
    return api.delete(`/event/delete/${id}`);
};

export const updateEvent = (id, data) => {
    return api.put(`/event/update/${id}`, data);
};
export const getUpcomingEvents = () => {
    return api.get("/event/getUpcomingEvents");
};
export const getPastEvents = () => {
    return api.get("/event/getPastEvents");
};


//gallery
export const postGallery = (data) => {
    return api.post("/gallery/create", data);
};

// export const postGallery = (data) => {
//     return api.post("/gallery/create", data, {
//         headers: {
//             'Content-Type': 'multipart/form-data',
//         }
//     });
// };


export const getAllGallery = () => {
    return api.get("/gallery/getall");
};

export const deleteGallery = (id) => {
    return api.delete(`/gallery/delete/${id}`);
};

export const updateGallery = (id, data) => {
    return api.put(`/gallery/update/${id}`, data);
};
//projects

export const postProject = (data) => {
    return api.post("/project/create", data);
};

export const getAllProjects = () => {
    return api.get("/project/getall");
};

export const getCountryBasedProjects = () => {
    return api.get("/project/getCountryBasedProjects");
};


export const deleteProject = (id) => {
    return api.delete(`/project/delete/${id}`);
};

export const updateProject = (id, data) => {
    return api.put(`/project/update/${id}`, data);
};
export const getUpcomingProjects = () => {
    return api.get("/project/getUpcomingProjects");
};
export const getPastProjects = () => {
    return api.get("/project/getPastProjects");
};
export const getProjectById = (id) => {
    return api.get(`/project/getProjectById/${id}`);
};


//getcountry for stripe

export const getCountry = () => {
    return api.get("/blog/getCountry");
};
